import { render, staticRenderFns } from "./RespuestaPagoAfiliacion.vue?vue&type=template&id=42c2b520&scoped=true&"
import script from "./RespuestaPagoAfiliacion.vue?vue&type=script&lang=js&"
export * from "./RespuestaPagoAfiliacion.vue?vue&type=script&lang=js&"
import style0 from "./RespuestaPagoAfiliacion.vue?vue&type=style&index=0&id=42c2b520&scoped=true&lang=css&"
import style1 from "./RespuestaPagoAfiliacion.vue?vue&type=style&index=1&id=42c2b520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2b520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDivider})
